import React, { useEffect, useRef, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "./swiper.css";
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/effect-fade";





import B1 from "../../assets/images/banner/b11old.jpg";
import B2 from "../../assets/images/banner/umrahbg.jpeg";
import B3 from "../../assets/images/banner/holiday.jpeg";
import logo from "../../assets/images/skysalepklogo.png";



import InputSection from "./InputSection";
import PriceDisplay from "../PriceDisplay";
import "./HeroTrustStats.css";

import { Compass, CreditCard, MapPin, MonitorCog, PhoneCall, Share, Share2, Umbrella } from "lucide-react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import InputSectionUmrah from "../Packagedetail/InputSectionUmrah";
import { trackEvent } from "../../utils/analytics";

const TOP_20_CITIES = [
  'Dubai', 'London', 'New York', 'Paris', 'Bangkok', 'Singapore', 'Istanbul',
  'Hong Kong', 'Kuala Lumpur', 'Barcelona', 'Amsterdam', 'Tokyo', 'Rome',
  'Madrid', 'Los Angeles', 'Toronto', 'Sydney', 'Frankfurt', 'Milan', 'Dublin'
];

const LETTER_DELAY_MS = 180;
const PAUSE_AFTER_TYPING_MS = 1300; // Wait 1.3 seconds after completing city name

function AnimatedHeroStat({ target, display, label }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !started.current) {
          started.current = true;
          const steps = 60;
          const duration = 1800;
          const increment = target / steps;
          let current = 0;
          const timer = setInterval(() => {
            current += increment;
            if (current >= target) {
              setCount(target);
              clearInterval(timer);
            } else {
              setCount(current);
            }
          }, duration / steps);
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [target]);

  return (
    <div ref={ref} className="hero-trust-stat flex items-center gap-2">
      <span className="hero-trust-value">{display(count)}</span>
      <span className="hero-trust-label">{label}</span>
    </div>
  );
}

function HeroTrustStats() {
  return (
    <div className="hero-trust-stats">
      <AnimatedHeroStat
        target={500000}
        display={(n) => `${Math.round(n / 1000)}K+`}
        label="Passengers Booked"
      />
      <AnimatedHeroStat
        target={500}
        display={(n) => `${Math.round(n)}+`}
        label="Destinations"
      />
      {[
        { value: "4.9★", label: "Average Rating" },
        { value: "24/7", label: "Expert Support" },
      ].map((s) => (
        <div key={s.label} className="hero-trust-stat flex items-center gap-2">
          <span className="hero-trust-value">{s.value}</span>
          <span className="hero-trust-label">{s.label}</span>
        </div>
      ))}
    </div>
  );
}

const BannerSection = (props) => {

  const [page, setPage] = useState()
  const [pkgtype, setpkgtype] = useState()
  const [cityIndex, setCityIndex] = useState(0)
  const [displayText, setDisplayText] = useState(TOP_20_CITIES[0])
  const [phase, setPhase] = useState('removing') // 'removing' | 'typing' | 'paused'
  const navigate = useNavigate()
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams()

  // Backspace then typewriter: remove current city letter by letter, then type next city letter by letter
  useEffect(() => {
    if (phase === 'paused') {
      // Wait before starting to remove
      const timeoutId = setTimeout(() => {
        setPhase('removing')
      }, PAUSE_AFTER_TYPING_MS)
      return () => clearTimeout(timeoutId)
    }

    const id = setInterval(() => {
      if (phase === 'removing') {
        setDisplayText((prev) => {
          if (prev.length <= 1) {
            setPhase('typing')
            setCityIndex((i) => (i + 1) % TOP_20_CITIES.length)
            return ''
          }
          return prev.slice(0, -1)
        })
      } else if (phase === 'typing') {
        const nextCity = TOP_20_CITIES[cityIndex]
        setDisplayText((prev) => {
          if (prev.length >= nextCity.length) {
            setPhase('paused')
            return prev
          }
          return nextCity.slice(0, prev.length + 1)
        })
      }
    }, LETTER_DELAY_MS)
    return () => clearInterval(id)
  }, [phase, cityIndex])
  useEffect(() => {

    const catId = searchParams.get("category");
    const pt = searchParams.get("type");
    setpkgtype(pt);
    setPage(location.pathname)
  }, [location.pathname, searchParams]);

  const getNo = () => {
    if (pkgtype == 'umrah')
      return '03338820922'
    else if (pkgtype == 'holiday')
      return '03338820922'
    else
      return '03338820922'
  }
  const getImg = () => {
    if (pkgtype == 'umrah')
      return B2
    else if (pkgtype == 'holiday')
      return B3
    else
      return B1
  }
  const getInputSection = () => {
    if (pkgtype == 'umrah')
      return <InputSectionUmrah />
    else if (pkgtype == 'holiday')
      return <InputSection />
    else
      return <InputSection />
  }
  const getHeadingPara = () => {
    if (pkgtype == 'umrah')
      return <p className="text-xl md:text-4xl text-white font-bold mt-12 md:mt-0 text-center md:text-left">Cheap Umrah Deals </p>
    else if (pkgtype == 'holiday')
      return <p className="text-xl md:text-4xl text-white font-bold mt-12 md:mt-0 text-center md:text-left">Cheap Holidays Deals </p>
    else
      if (props.banner_text)
        return <p className="text-xl md:text-4xl text-white font-bold mt-12 md:mt-0 text-center md:text-left">Cheap Flights {props.banner_text}</p>
      else
        return (
          <div className="flex justify-start">
            <p className="text-xl md:text-4xl text-white font-bold mt-4 md:mt-0 mb-2 md:mb-4 text-left pl-3 md:pl-5 md:whitespace-nowrap">
              <span className="block md:inline">Cheap Flights from Pakistan to</span>
              <span className="inline-block min-w-[0.5em] city-typewriter-cursor pl-0 md:pl-1">
                {displayText}
              </span>
            </p>
          </div>
        )
  }

  return (
    <div>
      <div className="relative w-full overflow-visible md:overflow-hidden pb-5 md:pb-8 bg-secondary md:bg-transparent">
        {/* Dark overlay - hidden on mobile since we use solid background color */}
        <div className="hidden md:block absolute z-[-1] bg-[rgba(0,0,0,0.4)] w-full h-full"></div>
        <BackSwiper getImg={getImg} />
        <div className="relative z-[1] w-full flex justify-center flex-col">
          {/* Desktop only: logo and nav links on the banner (scroll with image) */}
          <div className="hidden md:flex w-[90%] md:w-[80%] mx-auto items-center justify-between pt-5 pb-2">
            <div className="logo -mt-1.5" role="button" onClick={() => navigate('/')}>
              <img src={logo} className="w-[180px]" alt="SKYSALE PK" />
            </div>
            <div className="flex items-center gap-6">
              <button type="button" onClick={() => navigate('/')} className="text-white tracking-[1px] leading-7 font-medium hover:opacity-90">
                Fights
              </button>
              <button type="button" onClick={() => navigate('/packages')} className="text-white tracking-[1px] leading-7 font-medium hover:opacity-90">
                Packages
              </button>
              <button type="button" onClick={() => navigate('/allpackages?category=0&type=umrah')} className="text-white tracking-[1px] leading-7 font-medium hover:opacity-90">
                Umrah Packages
              </button>
              <button type="button" onClick={() => document.getElementById('my_modal_contact')?.showModal()} className="text-white tracking-[1px] leading-7 font-medium hover:opacity-90">
                Contact Us
              </button>
              <div
	                className="flex items-center gap-2 cursor-pointer hover:opacity-90"
	                role="button"
	                onClick={() => {
	                  trackEvent('phone_click', {
	                    source: 'home_banner',
	                    phone_number: getNo(),
	                    package_type: pkgtype || 'flights',
	                  });
	                  window.location.href = 'tel:03338820922';
	                }}
	              >
                <div className="bg-secondary p-2 rounded-full shadow-md">
                  <PhoneCall className="text-white w-4 h-4" />
                </div>
                <div className="flex flex-col leading-tight">
                  <span className="text-xs text-white/80 font-medium tracking-wide">Call Us Now</span>
                  <p className="text-lg font-bold text-white tracking-wide">{getNo()}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="md:hidden px-0 py-2 mt-8 pb-0 mb-0">
            {/* <p className="text-lg md:text-2xl text-white font-bold">Are you ready to travel</p> */}
            <div className="mt-2 mb-0">
              {getHeadingPara()}
            </div>
            {getInputSection()}
            <HeroTrustStats />
          </div>


          <div className="w-[90%] md:w-[80%] mx-auto grid grid-cols-1 md:grid-cols-2 gap-5 mt-6 md:mt-6">
            <div className="hidden md:block">
              {/* <p className="text-2xl text-white font-bold">Are you ready to travel</p> */}
              {getHeadingPara()}
              {getInputSection()}
              <HeroTrustStats />
            </div>

            <div className={location.pathname.includes('allpackages') || true ? `hidden` : ''}>


              <div className="w-full mt-7">
                <div className="flex gap-4 items-center mb-1">
                  <div className="rounded-lg bg-secondary flex justify-center items-center h-[40px] w-[40px]  md:h-[45px] md:w-[45px] drop-shadow-md drop-shadow-white">
                    <Umbrella className="text-white" />
                  </div>
                  <p className="text-xl md:text-2xl text-white font-bold">Financial Protection</p>
                </div>

                <p className="text-md md:text-lg text-white mt-2">Book with full confidence with us as all of our tickets protected.</p>
              </div>
              <hr className="text-white my-4" />



              <div className="w-full">
                <div className="flex gap-4 items-center mb-1">
                  <div className="rounded-lg bg-secondary flex justify-center items-center h-[40px] w-[40px]  md:h-[45px] md:w-[45px] drop-shadow-md drop-shadow-white">
                    <MonitorCog className="text-white" />
                  </div>
                  <p className="text-xl md:text-2xl text-white font-bold">Book With Confidence</p>
                </div>

                <p className="text-md md:text-lg text-white mt-2">Best Fare Guarantee. We offer the best fare possible and we will beat the quote you have got. We always stay in touch with our customers for their better asistance.</p>
              </div>


              <hr className="text-white my-4" />

              <div className="w-full">
                <div className="flex gap-4 items-center mb-1">
                  <div className="rounded-lg bg-secondary flex justify-center items-center h-[40px] w-[40px]  md:h-[45px] md:w-[45px] drop-shadow-md drop-shadow-white">
                    <CreditCard className="text-white" />
                  </div>
                  <p className="text-xl md:text-2xl text-white font-bold">Flexible Payment Options</p>
                </div>

                <p className="text-md md:text-lg text-white mt-2">Pay <PriceDisplay amount={50} displayCurrency="PKR" className="font-semibold" /> as an initial payment and remaining balance later in installments without any extra cost. There are no hidden charges.</p>
              </div>



            </div>


            <div className="w-full justify-center items-center col-span-2">
              {/* <p className="tracking-[3px] text-2xl font-[600]  leading-12 mt-0 text-white text-center">
                5 Star Rated Company
              </p>
              <p className="tracking-[2px] text-xl font-[500] leading-8 mt-2 text-white text-center ">
                We are the only 5 star rated company on google and facebook.
              </p> */}
            </div>


          </div>


        </div>
      </div>





    </div>
  );
};

const BackSwiper = ({ getImg }) => {
  return (
    <>
      {/* Desktop: Background image */}
      <div className="hidden md:block absolute inset-0 z-[-2] overflow-hidden">
        <img src={getImg()} className="h-full w-full object-cover" alt="" />
      </div>
    </>
  );
};

export default BannerSection;
